module.exports = __webpack_public_path__ + "static/media/country_jo.5e6dbe5c.webp";